module.exports = __webpack_public_path__ + "static/img/_6.84513c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_6.png
// module id = vzYR
// module chunks = 1